export default __webpack_public_path__ + "static/media/imageeleven.f8ac7fe4.gif";